export const SET_TEMPLATES = 'templates/setTemplates'
export const SAVE_TEMPLATE = 'templates/saveTemplate'
export const DESTROY_TEMPLATE = 'templates/destroyTemplate'
export const SELECT_TEMPLATE = 'templates/selectTemplate'
export const CLEAR_TEMPLATE = 'templates/clearTemplate'



// WEBPACK FOOTER //
// ./src/modules/templates/store/mutations_types.js